<template>
  <div id="app">
    <router-view/>
    <confirm :titleTig="titleTig" :message='message' :okText="okText" @confirmok="confirmok" :shows="show"></confirm>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Confirm from './components/confirm/main.vue'
export default {
  components: {
    Confirm,
  },
  data() {
    return {
      show: false,
      message:'',
      titleTig:'',
      okText:''
    };
  },
  computed: {
    ...mapGetters(['token'])
  },
  created() {
    let self = this;

    this.onLoad();

    self.$http.interceptors.request.use(function (config) {

      if(self.$storage.getLs("token") !== self.token){
        self.show = true;
        self.titleTig = '用户已变更'
        self.okText = '返回欢迎页面'
        self.message = '检测到用户已变更，请点击按钮返回欢迎页面。'
        return
      }

      if(self.$storage.hasLs("userinfo")){
        self.$store.commit('USER_INFO', self.$storage.getLs("userinfo"))
      }
      let tokenOld = self.$storage.getLs("token")
      config.headers["Authorization"] = "Bearer " + tokenOld;
      self.$store.commit('TOKEN', tokenOld)
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    self.$http.interceptors.response.use(
      response => {
        if ( response.data.recode == 500 ) {
          // this.show = true
          // this.titleTig = '系统出错'
          this.$message.error(response.data.msg || '错误：' + response.data.recode);
        }
        
        return response;
      },
      error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              this.show = true
              this.titleTig = '授权失败'
              this.message = "授权失败,请从有市重新进入！"
              // self.$router.replace({ path: "/" });
              // location.reload();
              localStorage.removeItem("token");
              setTimeout(() => {
                window.location.href = this.$conf.Api.url + '/my-account'
              }, 4000)
              
              break;
            case 400:
              this.show = true
              this.titleTig = '请求有误'
              this.message = "请求有误"
              break;
            case 404:
              this.show = true
              this.titleTig = '404'
              this.message = "404"
              break;
            case 500:
              //self.getToken();
              this.show = true
              this.titleTig = '系统出错'
              this.message = "500：系统出错"
              break;
            case 504:
              this.show = true
              this.titleTig = '请求超时'
              this.message = "504：请求超时"
              break;
          }
          
        }
        return Promise.reject(error.response.data);
      }
    );
    
    
  },
  mounted() {
    let self = this;
    document.addEventListener("visibilitychange", function() {
      if(document.visibilityState == 'visible' && self.$storage.getLs("token") !== self.token){
        self.show = true;
        self.titleTig = '用户已变更'
        self.okText = '返回欢迎页面'
        self.message = '检测到用户已变更，请点击按钮返回欢迎页面。'
      }
    });
  },
  methods: {
    onLoad(cb) {
      let self = this;
      let instance = self.$http.create();
      instance.defaults.timeout = 6000;
      const params = self.$storage.getParams(window.location);
      if (params.token) {

        self.$store.dispatch("SET_TOKEN", params.token);
        self.$storage.setLs( 'token', params.token)
        instance.defaults.headers.common["Authorization"] = "Bearer " + params.token;
        self.$store.commit('TOKEN', params.token)
        self.$router.replace({ path: window.location.pathname });
        self.$store.dispatch("LOGIN_INFO")

      } else if (self.$storage.hasLs("token")) {
        let token = self.$storage.getLs("token");
        instance.defaults.headers.common["Authorization"] = "Bearer " + token; // 设置 Authorization Base64.decode('111') 解码  Base64.encode('111') 编码
        self.$store.commit('TOKEN', token)
        if(self.$storage.hasLs("userinfo")){
          self.$store.commit('USER_INFO', self.$storage.getLs("userinfo"))
        }
        if(self.$storage.hasLs("shopinfo")){
          self.$store.commit('SHOPINFO', self.$storage.getLs("shopinfo"))
        }
      } else {
        if (process.env.NODE_ENV !== 'development') {
          window.location.href =  self.$conf.Api.url + '/my-account'
        } else {
          this.getToken()
        }
      }
      typeof cb == "function" && cb(true);
    },
    getToken() { // 测试用
      let self = this;
      let instance = self.$http.create();
      instance.defaults.timeout = 6000;
      instance.defaults.headers.common["Accept"] = "application/json"; // 设置 Accept
      instance.defaults.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded"; // 设置 Content-Type
      instance.defaults.headers.common["Authorization"] =
        "Basic " + self.$Base64.encode("13798647463:" + self.$md5("111111")); // 设置 Authorization 13798647463 13790022062
      self.$store.dispatch("TOKEN_DPH");
    },
    confirmok() {
      this.show = false
      if (this.titleTig == '用户已变更') {
        this.$router.replace({ path: "/my/welcome" });
        location.reload();
      }
    }
  }
};
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  background: rgba(194, 194, 194, 1);
}
* {
  outline: none;
  font-family: "Helvetica Neue", Helvetica, Arial, Tahoma, "Microsoft Yahei",
    "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
}
body,
button,
input,
select,
textarea {
  font: 12px/1.5 "微软雅黑", tahoma, arial, \5b8b\4f53;
}
body,
p,
form,
ul,
li,
h1,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  list-style: none;
}
img {
  border: none;
  vertical-align: top;
}
a {
  text-decoration: none;
  color: #333;
}
.wrap1200 {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.wrap1400 {
  position: relative;
  width: 1400px;
  margin: 0 auto;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fix {
  zoom: 1;
}
.fix:after {
  display: block;
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.top10{
  margin-top: 10px;
}
.top20 {
  margin-top: 20px;
}
.bottom20 {
  margin-bottom: 20px;
}
.ml20 {
  margin-left: 20px;
}
.va-bt {
  vertical-align:bottom;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.al {
  text-align: left;
}
.ar {
  text-align: right;
}
.ac{
  text-align: center;
}
.icons {
  background: url(./assets/icon-m-h.png) no-repeat;
}
table {
  background-color: #fff;
  text-align: center;
  table-layout: fixed;
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #e7e7e7;
}
.list-box thead {
  background-color: #f8f8f8;
  color: #999;
}
.list-bg thead {
  background-color: #fff;
}
.list-box .title,
.list-box td,
.list-box th {
  border-bottom: 1px solid #e7e7e7;
}
.list-box,
.list-bg {
  margin: 0 0 10px;
}
.list-box td {
  line-height: 18px;
  padding: 10px 0;
}

.list-box td,
.list-box th {
  line-height: 18px;
  padding: 10px 0;
  color: #666;
  font-weight: inherit;
}

.list-box tr td img {
  width: 76px;
  height: 76px;
  margin-right: 10px;
}

.list-box .order-info .first {
  text-align: left;
  padding: 10px;
}
.list-box thead th.first {
  text-align: left;
  text-indent: 10px;
}
.icon-shop {
  background-position: -35px 0px;
  display: inline-block;
  width: 15px;
  height: 14px;
  cursor: pointer;
  vertical-align: -3px;
  margin-right: 2px;
}
.w-s-b{
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.el-message-box {
  width: 350px !important;
}
.el-message-box__header{
  height: 42px;
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 2px 2px 0 0;
  text-align: left;
  padding: 0 !important;
}
.el-message-box__title span{
  height: 42px;
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 2px 2px 0 0;
  text-align: left;
  margin-left: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.el-message-box__close{
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  color: #999;
  text-align: center;
  cursor: pointer;
  z-index: 6;
  font-weight: inherit;
  line-height: 42px;
  transition: 1s ease-in-out 0s;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
  -o-transition: 1s ease-in-out 0s;
  -webkit-backface-visibility: hidden;
}
.el-message-box__close:hover {
  color: #999;
  -moz-transform: scale(1.1) rotate(360deg);
  -webkit-transform: scale(1) rotate(360deg);
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -moz-transition: 1s ease-in-out 0s;
  -webkit-transition: 1s ease-in-out 0s;
}
.el-message-box__headerbtn {
  top: 0 !important;
  right: 10px !important;
}

.el-button--primary {
    box-shadow: none !important;
    color: #fff !important;
    background-color: #ff7300 !important;
    border-color: #ff7300 !important;
    vertical-align: middle !important;
}
.el-button--primary:hover {
  color: #fff !important;
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  opacity: 0.7 !important;
}
.el-message-box__btns{
  text-align: center !important;
}
</style>
